import script from "./VersionHistoryModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VersionHistoryModal.vue?vue&type=script&setup=true&lang=ts"

import "./VersionHistoryModal.vue?vue&type=style&index=0&id=4e702c32&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e702c32"]])

export default __exports__